import * as xlsx from "xlsx"
import * as FileSaver from "file-saver";

export function exportFileTestSimilaridade(dataPrepared: any[], filetype: string) {
  const rows = (Array.isArray(dataPrepared) ? dataPrepared : []).map((item: any) => {

    const similaridadeFormatada = item.SIM_COS 
      ? `${(item.SIM_COS * 100).toFixed(2)}%` 
      : "";

    return {
      "GTIN": item.GTIN || "",
      "Descrição": item.DESCRICAO || "",
      "Marca": item.MARCA || "",
      "Conteúdo Líquido": item.CONT_LIQUIDO || "",
      "Similaridade": similaridadeFormatada,
      "Tipo GTIN": item.TIPO_GTIN || ""
    };
  });

  const ws = xlsx.utils.json_to_sheet(rows);

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = xlsx.write(wb, { bookType: filetype === "xls" ? "xls" : "csv", type: "array" });
  
  // Salva o arquivo
  const data = new Blob([excelBuffer]);
  FileSaver.saveAs(data, `resultado_similaridade.${filetype}`);
}